import { render, staticRenderFns } from "./MarketingRuleList.vue?vue&type=template&id=50d1375f&scoped=true&"
import script from "./MarketingRuleList.vue?vue&type=script&lang=js&"
export * from "./MarketingRuleList.vue?vue&type=script&lang=js&"
import style0 from "./MarketingRuleList.vue?vue&type=style&index=0&id=50d1375f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d1375f",
  null
  
)

export default component.exports